import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../mdae-framework";

export const TOGGLE_VIEW_CARAC_MAPPINGS_PANEL =
  "TOGGLE_VIEW_CARAC_MAPPINGS_PANEL";

const initialState = {
  isViewCARCMappingPanelOpen: false,
};
export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_VIEW_CARAC_MAPPINGS_PANEL:    
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    default:
      return state;
  }
}
